import { html } from 'lit-element';

import { FormElement } from '@elab/components/connected/forms/Form';
import { compareState } from '@elab/core/utils/webComponent';

class HiddenInputField extends FormElement {
    createRenderRoot() {
        return this;
    }

    shouldUpdate(changedProps) {
        return [
            ['fieldValue', 'value'],
            ['fieldValue', 'type'],
            ['fieldValue', 'name'],
        ].some(item => compareState(this, changedProps, ...item));
    }

    render() {
        if (this.fieldValue) {
            const { name, type, value } = this.fieldValue;
            return html`
                <input name="${name}" type="${type}" value="${value}" />
            `;
        }
        return html``;
    }
}

export default () => customElements.define('e2-hidden-input-field', HiddenInputField);
